import {
  catchFailure,
  flatMap,
  mapErrorPassThrough,
  pipe,
  succeed,
  trySync,
} from "@otto-ec/assets-core-utils/nano-effect";
import type { OcSheetV1Props } from "../../v1/SheetV1.types.g";

/**
 *
 */
const parseStringAsB64 = trySync(atob, mapErrorPassThrough<Error>);

/**
 *
 */
const parseJsonToSheetParams = trySync(JSON.parse<OcSheetV1Props>, mapErrorPassThrough<Error>);

export const parseSheetIdOrProps = flatMap((paramValue: string) =>
  pipe(
    parseStringAsB64(paramValue),
    catchFailure(() => succeed(paramValue)),
    flatMap(parseJsonToSheetParams),
    catchFailure(() => succeed(paramValue)),
  ),
);

/**
 *
 *
 *
 *
 *
 *
 */
export const makeSheetPropsWithoutOpen = (
  ...props: (Partial<OcSheetV1Props> | undefined | null)[]
): Omit<Partial<OcSheetV1Props>, "open"> => {
  const result = Object.assign({}, ...props);
  /*                                                                        */
  /*                                 */
  delete result.open;
  return result;
};
